<template>
  <div class="text-container md:md-text-container">
    <div class="grid grid-cols-1 md:grid-cols-10 gap-5">
      <div class="md:col-span-8">
        <Heading text="Words for your Happy Place"/>
      </div>
      <div class="md:col-span-8">
        Please type any words you associate with your
      </div>
      <div class="md:col-span-8 theme">
        Happy Place
      </div>
      <div class="md:col-span-8">
        You will have 60 seconds.
      </div>
      <div class="md:col-span-8">
        <Button v-bind:onClick="nextPage" text="Continue"/>
      </div>
    </div>
    <audio ref="aud" src="@/assets/audio/lets-begin.mp3" />
  </div>
</template>

<script>
import Button from '@/components/Button.vue';
import Heading from '@/components/Heading.vue';

export default {
  name: 'LetsBegin',
  components: {
    Button,
    Heading,
  },
  methods: {
    nextPage() {
      this.$refs.aud.pause();
      this.$store.commit('setView', 'WordEntry');
    },
  },
  mounted() {
    this.$refs.aud.play();
  },
};
</script>

<style scoped>
.theme {
  color: #9a9899;
  font-size: 2em;
}
</style>
